import { IonModal } from '@ionic/react'
import React from 'react'
import './index.scss'

interface IModalProps {
  title?: string;
  des?: string;
  reject?: () => void;
  resolve?: () => void;
}

const ResultAlert: React.FC<IModalProps> = (props: IModalProps) => {
  const { title, des, reject, resolve } = props
  return (

    <IonModal
      cssClass='text-tip-alert'
      isOpen
      onDidDismiss={reject}
    >
      <div className='modal-content'>
        {
          title && <div className='title'>{title}</div>
        }
        {
          des && <div className='des-main'>{des}</div>
        }
        <div className='modal-btn' data-cypid='textTipAlert' onClick={resolve}>
          <div>{i18n.t('newCart.confirm')}</div>
        </div>
      </div>
    </IonModal>
  )
}

export default ResultAlert
